import axiosInstance from '../axios'

const PAT_LOG_PREFIX = '[PAT API]'

/**
 * Calls PAT API via SaleSetupAPI to get the sale type for a given vehicle VIN.
 * Triggered during drag-and-drop on the Assign Inventory page.
 *
 * @param {string} vin - Vehicle Identification Number
 * @returns {Promise} Axios promise resolving to { vin, saleType }
 */
export function getPatSaleType(vin) {
    const normalizedVin = String(vin || '').trim()
    const startedAt = Date.now()

    console.log(`${PAT_LOG_PREFIX} [single][request] vin=${normalizedVin}`)

    return axiosInstance.get('/vehicle/pat-sale-type', {
        params: { vin: normalizedVin }
    })
        .then(response => {
            console.log(
                `${PAT_LOG_PREFIX} [single][success] vin=${normalizedVin} saleType=${response?.data?.saleType || 'N/A'} status=${response?.status} durationMs=${Date.now() - startedAt}`
            )
            return response
        })
        .catch(error => {
            console.error(
                `${PAT_LOG_PREFIX} [single][error] vin=${normalizedVin} status=${error?.response?.status || 'N/A'} durationMs=${Date.now() - startedAt} message=${error?.message}`,
                error?.response?.data
            )
            throw error
        })
}

/**
 * Calls PAT batch API via SaleSetupAPI for one or multiple vehicles.
 * Sends vehicleTypeMap alongside VINs so backend mock can classify truck/whole-car correctly.
 * Works for drag-drop ([vehicle]) and auto-assign ([vehicle1, vehicle2, ...]).
 *
 * @param {Array} vehicles - Vehicle objects from inventory (must have .vin; .vehicleType used for mock)
 * @returns {Promise} Axios promise resolving to [{ vin, saleType }]
 */
export function getPatSaleTypesBatch(vehicles = []) {
    const startedAt = Date.now()
    const validVehicles = vehicles.filter(v => v && v.vin)
    const validVins = [...new Set(validVehicles.map(v => String(v.vin).trim()))]

    // Build vehicleTypeMap: { [vin]: vehicleType } — used by backend mock only
    const vehicleTypeMap = {}
    validVehicles.forEach(v => {
        const vin = String(v.vin).trim()
        if (v.vehicleType) vehicleTypeMap[vin] = v.vehicleType
    })

    console.log(`${PAT_LOG_PREFIX} [batch][request] vins=${validVins.length}`, validVins, vehicleTypeMap)

    if (validVins.length === 0) {
        console.log(`${PAT_LOG_PREFIX} [batch][skip] No valid VINs to request`)
        return Promise.resolve({ data: [] })
    }

    return axiosInstance.post('/vehicle/pat-sale-types', {
        vins: validVins,
        vehicleTypeMap: Object.keys(vehicleTypeMap).length > 0 ? vehicleTypeMap : undefined
    })
        .then(response => {
            const resultCount = response?.data?.length || 0
            console.log(
                `${PAT_LOG_PREFIX} [batch][success] requested=${validVins.length} received=${resultCount} status=${response?.status} durationMs=${Date.now() - startedAt}`
            )
            return response
        })
        .catch(error => {
            console.error(
                `${PAT_LOG_PREFIX} [batch][error] requested=${validVins.length} status=${error?.response?.status || 'N/A'} durationMs=${Date.now() - startedAt} message=${error?.message}`,
                error?.response?.data
            )
            throw error
        })
}
